import PropTypes from 'prop-types'
import Slider from 'rc-slider'
import { throttle } from 'throttle-debounce'

import useRouterQueryStateRange from 'hooks/useRouterQueryStateRange'

import Text from 'components/Text'

import { Root, Values } from './ProductsFilterRange.style'

const step = 1000

const ProductsFilterRange = ({ name, values: { min, max }, formatter }) => {
  // [rc-slider] max - min should be evenly divisible by the step value
  min = Math.floor(min / step) * step
  max = Math.ceil(max / step) * step

  const [state, setState] = useRouterQueryStateRange(name)

  const lowerValue = state[0] || min
  const upperValue = state[1] || max
  const lowerValueFormatted = formatter ? formatter(lowerValue) : lowerValue
  const upperValueFormatted = formatter ? formatter(upperValue) : upperValue

  const handleChange = throttle(300, (value) => setState(value))

  // Enable to immediately persist the range values to the URL when the component mounts
  // useEffect(() => {
  //   setState([min, max])
  // }, [setState, min, max])

  return (
    <Root>
      <Slider
        range
        allowCross={false}
        min={min}
        max={max}
        step={step}
        defaultValue={[min, max]}
        onAfterChange={handleChange}
      />
      <Values>
        <Text>{lowerValueFormatted}</Text>
        <Text>{upperValueFormatted}</Text>
      </Values>
    </Root>
  )
}

ProductsFilterRange.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.shape({ min: PropTypes.number, max: PropTypes.number }).isRequired,
}

ProductsFilterRange.defaultProps = {
  name: 'foo',
  values: { min: 0, max: 2000 },
}

export default ProductsFilterRange
